import { useSelector } from "react-redux";
import { Form, Row, Col, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { HotelSelect } from "../../components/common/HotelSelect";
import { HotelAccountSettings } from "../../components/fact-sheet/HotelAccountSettings";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { mdlHotel } from "../../models/domain/Hotel";

export default function HotelAccount() {
    const { t } = useTranslation();
    const user = useSelector((state: any) => state.site.user);
    const [selectedHotel, setSelectedHotel] = useState<string>('');
    const [hotelData, setHotelData] = useState<mdlHotel>();

    const onHotelDataLoad = (data: mdlHotel) => {
        setHotelData(data);
    };

    return (
        <div className="nk-content">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <PageHeaderSection
                            pageTitle={t('hotelAccount.title')}
                            pageDescription={t('hotelAccount.description')}
                        />
                        <Card className="hotel-account">
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label={t('hotelAccount.selectHotel')}>
                                        <HotelSelect
                                            onChange={(value: string) => setSelectedHotel(value)}
                                            value={selectedHotel}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {selectedHotel && (
                                <>
                                    <HotelAccountSettings
                                        selectedHotel={selectedHotel}
                                        selectedLanguage={user?.currentLanguage}
                                        onDataLoad={onHotelDataLoad}
                                    />

                                    {/* Map Section */}
                                    {hotelData?.lat && hotelData?.lon && (
                                        <div className="mt-4">
                                            <h4>{t('hotelAccount.location')}</h4>
                                            <hr />
                                            <div style={{ height: '400px', width: '100%', backgroundColor: '#f0f2f5', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <iframe
                                                    src={`https://www.openstreetmap.org/export/embed.html?bbox=${Number(hotelData.lon) - 0.01}%2C${Number(hotelData.lat) - 0.01}%2C${Number(hotelData.lon) + 0.01}%2C${Number(hotelData.lat) + 0.01}&layer=mapnik&marker=${hotelData.lat}%2C${hotelData.lon}`}
                                                    width="100%"
                                                    height="100%"
                                                    style={{ border: 0 }}
                                                    allowFullScreen
                                                    loading="lazy"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
} 